var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"text-field",attrs:{"type":"text","placeholder":this.placeholder},domProps:{"value":this.value},on:{"input":function($event){return _vm.changesHandler($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }